export class ScoreService {
    static path = 'score';

    /**
     * @return {String}
     */
    static getEndpoint() {
        return process.env.VUE_APP_RISK_MODEL_ENDPOINT;
    }

    static async get(rfc) {
        return await axios.get(`${this.getEndpoint()}/cdc-service/check/${rfc}`);
    }

    static async request(data) {
        return await axios.post(`/api/credit-score/personal`, data)
    }

    static async update(rfc, data) {
        return await axios.post(`${this.getEndpoint()}/cdc-service/score/${rfc}`, data)
    }
}
